module.exports = __webpack_public_path__ + "img/cov-community.fd59ef89.jpg";